import { render } from "./PageText.vue?vue&type=template&id=63a747a9"
import script from "./PageText.vue?vue&type=script&lang=js"
export * from "./PageText.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/api-staging.champagne-booking.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__